import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useStepsWizard } from 'hooks/useStepsWizard';
import searchParams from 'constants/searchParams';
import paths from 'constants/paths';

const RedirectNA = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const preview = params.get(searchParams.preview);
  const na = useSelector((state) => state.na);
  const externalAccessConfig = useSelector((state) => state.externalAccessConfig);
  const isExternalAccess = useSelector((state) => state.general.isExternalAccessMode);
  const redirectTo = na.scoreCardReached ? paths.steps.scorecard : na.lastStep;
  const { goToStep } = useStepsWizard({
    naId: na.id,
    preview,
    isExternalAccess,
    accessKey: externalAccessConfig.accessKey,
  });

  useEffect(() => {
    goToStep({ step: redirectTo, replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectTo]);
};

export default RedirectNA;
